export { default } from './FeedbackPopUp';



// WEBPACK FOOTER //
// ./src/components/Feedback/FeedbackPopUp/index.js